import React from 'react';
import PropTypes from 'prop-types';

const CustomTreeRenderer = ({ item, column }) => item && column && item[column] && (
  <span className="tree-item">
    {`${item[column]} [${item.id}]`}
  </span>
);

CustomTreeRenderer.displayName = 'CustomTreeRenderer';

CustomTreeRenderer.propTypes = {
  item: PropTypes.object,
  column: PropTypes.string,
};

export default CustomTreeRenderer;
